/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "./src/components/global.css"

import React from "react"
import { ItemProvider } from "./src/contexts/itemContext"
import ErrorBoundary from "./src/components/ErrorBoundary"
export const wrapRootElement = ({ element }) => (
  <ItemProvider>
    <ErrorBoundary>{element}</ErrorBoundary>
  </ItemProvider>
)
